<section class="homepage-benefits">
  <div class="homepage-section-container">
    <h2 class="display-h2 mb-8 lg:mb-16 sr-only">{{ 'home-page.benefits.heading' | translate }}</h2>
    <div class="items">
      <div *ngFor="let benefit of benefits" class="item" [class.item-highlighted]="benefit.isHighlighted">
        <img [src]="'/assets/img/homepage/' + benefit.image" [alt]="benefit.alt" class="item-image" />
        <h3 class="display-h3 mb-4" [innerHTML]="benefit.heading | translate"></h3>
        <div class="flex flex-1 flex-col display-paragraph-large">
          <div class="flex-1 mb-4">
            <p class="max-w-[25ch] leading-7" [innerHTML]="benefit.text | translate"></p>
          </div>
          <app-link-pair
            *ngIf="benefit.routerLink && !benefit.isHighlighted"
            [routerLink]="benefit.routerLink"
            [addressLabel]="'home-page.benefits.more' | translate"
            addressIcon="/assets/img/arrow-right-blue.svg"
          ></app-link-pair>
          <app-link-pair
            *ngIf="benefit.href && !benefit.isHighlighted"
            [addressHref]="benefit.href"
            [addressLabel]="'home-page.benefits.more' | translate"
            addressIcon="/assets/img/arrow-right-blue.svg"
          ></app-link-pair>
          <!-- Highlighted item uses button instead of link -->
          <a
            *ngIf="benefit.routerLink && benefit.isHighlighted"
            [routerLink]="benefit.routerLink"
            class="cm-button cm-button-secondary"
          >
            <span class="cm-button-label">
              {{ 'home-page.benefits.more' | translate }}
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
